<template>
  <div class="product-card-type-f">
    <div class="product-card-type-f__img-wrapper pc__images">
      <ProductImage
        :enableImageCarousel="false"
        :selectedColor="product.selectedFirstOption"
        :product="product.product"
      />

      <div v-if="averageRating > 0" class="product-card-type-f__product-rating">
        <svg aria-hidden="true">
          <use xlink:href="#rating-star"></use>
        </svg>

        <strong>{{ averageRating }}</strong>
      </div>
    </div>

    <div class="product-card-type-f__details-wrapper">
      <span class="product-card-type-f__product-title" role="heading" aria-level="2">
        {{ product.title }}
      </span>

      <div class="product-card-type-f__price-wrapper">
        <span :class="['product-card-type-f__price', { bold: comparePrice != discountPrice }]">
          {{ formatPrice(discountPrice) }}
        </span>
        <span v-if="comparePrice != discountPrice" class="product-card-type-f__compare-price">
          {{ formatPrice(comparePrice) }}
        </span>
      </div>
    </div>

    <button class="btn product-card-type-f__cta" @click="toggleQuickView" data-ctl-click="true">
      See More
    </button>
  </div>
</template>

<script setup>
  /** ProductCardTypeF is used in New Complete the look section in PDP */
  import { toRefs, computed } from 'vue';
  import productCardProps from './product-card-props';
  import ProductImage from './product-image.vue';

  const props = defineProps({
    product: productCardProps.product,
  });

  const { product } = toRefs(props);

  const discountPrice = computed(() => {
    const { price, compare_at_price } = product.value;
    const customerDiscountVal = window.customerDiscount(product.value.product.tags);

    if (compare_at_price > 0) {
      return Math.min(compare_at_price * (1 - customerDiscountVal), price);
    } else {
      return price * (1 - customerDiscountVal);
    }
  });

  const comparePrice = computed(() => {
    const { price, compare_at_price } = product.value;

    if (compare_at_price > 0) {
      return compare_at_price;
    } else {
      return price;
    }
  });

  const averageRating = computed(() =>  product?.value.product?.review_rating?.reviews_average || 0);

  const formatPrice = (price) => {
    return window.formattedPrice(price / 100);
  };

  const toggleQuickView = () => {
    window.toggleDrawer(true, 'QuickView', {
      product: product.value.product,
      selectedColor: product.value.selectedFirstOption,
      expandProductDetailsInPlace: true,
    });
  };
</script>
